<template>
  <div class="management-page-outer-container">
    <router-view />
    <all-lists-data-table
      v-if="$route.name === 'list-settings'"
      :pagination-from-parent="pagination"
      @update-pagination="pagination = $event"
      :search-from-parent="allListsSearch"
      @update-search="allListsSearch = $event"
    >
      <management-add-button
        :label="$t('AddCustomList')"
        @buttonClick="$router.push({ name: 'custom-list-create' })"
        :disabled="!this.userHasManagementPermission('custom_list_store')"
        :listMissingPermissions="[]"
      />
    </all-lists-data-table>
  </div>
</template>

<script>
import ManagementAddButton from "../../../Management/ManagementAddButton";
import AllListsDataTable from "@/components/SystemManagement/SystemSettings/ListsSettings/AllListsDataTable";
import { checkPermissionsMixin } from "@/mixins/checkPermissionsMixin";

export default {
  components: {
    ManagementAddButton,
    AllListsDataTable
  },

  mixins: [checkPermissionsMixin],

  data() {
    return {
      pagination: {
        rowsPerPage: 10
      },
      allListsSearch: ""
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SystemManagement/SystemSettings/ListsSettings/ListsSettingsPage.vue